import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { OpenReviewPostEntryModuleName } from '@/store/modules/modules'

export class OpenReviewPostEntryViewModel {
  private store = useStore()

  entryList: ComputedRef<ReviewEntry[]> = computed(
    () => this.store.getters[`${OpenReviewPostEntryModuleName}/entryList`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${OpenReviewPostEntryModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${OpenReviewPostEntryModuleName}/error`])

  async fetchReviewEntryList(problemId: string): Promise<void> {
    await this.store.dispatch(`${OpenReviewPostEntryModuleName}/fetchReviewEntryList`, { problemId })
  }
}
